import { Typography } from "@mui/material";
import { styled as muiStyled } from "@mui/system";
import styled from "styled-components";

const COLORS = {
    cardBg: "#0A1A3C",
    cardHover: "#122855",
    arrowBg: "#DDDDDD",
    arrowHover: "#EEE",
    arrowColor: "#9F9999",
};

export const Container = styled.div`
    width: 100%;
    max-width: 1070px;
    margin: 0rem auto;
    border-radius: 20px;
    padding: 1rem 0;
`;

export const RelativeContainer = styled.div`
    position: relative;

    @media (min-width: 1200px) {
        max-width: 1045px;
        margin: 0 auto;
    }
`;

export const CarouselArea = styled.div`
    overflow: hidden;
    width: ${({ width }) => `${width}px`};
    margin: 0 auto;
    padding: 16px 15px 0px 0px;
`;

export const CarouselContent = styled.div`
    display: flex;
    gap: ${({ gap }) => `${gap}px`};
    transform: translateX(-${props => props.translate}px);
    transition: transform 0.3s ease-in-out;
    will-change: transform;
`;

export const CategoryCard = styled.a`
    flex: 0 0 auto;
    width: ${({ width }) => `${width}px`};
    height: 140px;
    background: linear-gradient(
    145deg,
    #ffffff 0%,
    #f6f6f6 25%,
    #eaeaea 50%,
    #f6f6f6 75%,
    #ffffff 100%
    );
    border: 1px solid darkgray;
    color: grey;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 8px;
    cursor: pointer;
    text-decoration: none;
    transition: background-color 0.2s ease;
    font-weight: 900;

    &:hover {
        background-color: ${COLORS.cardHover};
    }
`;

export const CategoryName = styled.span`
    font-weight: 600;
    font-size: ${({ isMobile, isSmall }) =>
        isSmall ? (isMobile ? "10px" : "12px") : isMobile ? "14px" : "16px"};
    line-height: 1.2;
    max-width: 90%;
    text-align: center;
    overflow-wrap: break-word;
    hyphens: auto;
    word-break: break-word;
`;

export const ArrowButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    background-color: ${COLORS.arrowBg};
    color: ${COLORS.arrowColor};
    border: none;
    border-radius: 50%;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);

    &:hover {
        background-color: ${COLORS.arrowHover};
    }
`;

export const ArrowButtonLeft = styled(ArrowButton)`
    left: 0;

    @media (min-width: 1200px) {
        left: -48px;
    }
`;

export const ArrowButtonRight = styled(ArrowButton)`
    right: 0;

    @media (min-width: 1200px) {
        right: -48px;
    }
`;

export const Title = muiStyled(Typography)(() => ({
  fontWeight: 600,
  color: "#0095FE",
  fontSize: "20px",
  margin: "0 auto 1rem",
  maxWidth: "909.5px",

  '@media (max-width: 768px)': {
    margin: "0 auto 1rem 16px",
    maxWidth: "100%",
  },

  '@media (min-width: 768px) and (max-width: 1024px)': {
    width: "678px",
  },

  '@media (min-width: 1200px)': {
    maxWidth: "1045px",
  },
}));

export const CarouselAreaMobile = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  padding: 16px 0 16px 16px; /* 👈 padding ESQUERDO AQUI */
  scroll-padding-left: 16px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CarouselContentMobile = styled.div`
  display: flex;
  gap: 16px;
`;



